import { Carousel } from '@mantine/carousel'
import { Box, Card, Skeleton } from '@mantine/core'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import useSWR from 'swr'
import NextSVG from '../components/buttons/next_carousel_button'
import PreviousSVG from '../components/buttons/previous_carousel_button'
import TitleDivider from './divider.js'

const fetcher = (url) => fetch(url).then((res) => res.json())

const SimilarCarousel = ({ uid, type, vectorizer, title }) => {
  const t = useTranslations('SimilarCarousel')
  const { data, error } = useSWR(
    `/api/api_ext/content/similar/bb?id=${uid}&type=${type}&limit=10&vectorizer=${vectorizer}`,
    fetcher
  )

  const [similar, setSimilar] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (data) {
      setSimilar(data)
      setIsLoading(false)
    }
    if (error) {
      console.error('Failed to load similar content', error)
      setIsLoading(false)
    }
  }, [data, error])

  if (isLoading) {
    return (
      <Box mt={24}>
        <TitleDivider titleText={t('moreLikeThis')} />
        <Carousel
          h={222}
          mt={30}
          mb={20}
          slideGap="xl"
          slideSize="12.5%"
          loop={false}
          align="start"
          slidesToScroll={1}
          nextControlIcon={<NextSVG />}
          previousControlIcon={<PreviousSVG />}
          styles={{
            control: {
              opacity: 1,
              cursor: 'default',
              backgroundColor: 'transparent',
              border: 'transparent',
              transform: 'none',
              transition: 'none',

              '&[data-inactive]': {
                opacity: 0,
                cursor: 'default',
                visibility: 'hidden',
                pointerEvents: 'none',
                width: 0,
                margin: 0
              }
            }
          }}
        >
          {Array.from({ length: 5 }).map((_, index) => (
            <Carousel.Slide key={index}>
              <Card
                w={140}
                h={222}
                p={0}
                style={{ width: '140px', height: '222px' }}
              >
                <Box sx={{ width: '100%', height: '100%', padding: 10 }}>
                  <Skeleton height={100} width="100%" radius="md" />
                </Box>
              </Card>
            </Carousel.Slide>
          ))}
        </Carousel>
      </Box>
    )
  }

  if (!similar.length) {
    return null
  }

  return (
    <Box mt={24}>
      <TitleDivider titleText={t('moreLikeThis') + title.toUpperCase()} />
      <Carousel
        h={222}
        mt={30}
        mb={20}
        slideGap="xs"
        slideSize="10.5%"
        loop={false}
        align="start"
        slidesToScroll={1}
        nextControlIcon={<NextSVG />}
        previousControlIcon={<PreviousSVG />}
        styles={{
          control: {
            opacity: 1,
            cursor: 'default',
            backgroundColor: 'transparent',
            border: 'transparent',
            transform: 'none',
            transition: 'none',

            '&[data-inactive]': {
              opacity: 0,
              cursor: 'default',
              visibility: 'hidden',
              pointerEvents: 'none',
              width: 0,
              margin: 0
            },
            '@media (max-width: 768px)': {
              display: 'none'
            }
          }
        }}
      >
        {similar
          .filter((item) => item.poster) // Filtra solo los elementos que tienen un poster
          .map((item) => (
            <Carousel.Slide key={item.uid}>
              <Card
                w={140}
                h={222}
                p={0}
                style={{ width: '140px', height: '222px' }}
              >
                <Link
                  href={`/${type}/${item.slug ? item.slug : item.uid}`}
                  prefetch={false}
                  passHref
                >
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      position: 'relative'
                    }}
                  >
                    <Image
                      src={`https://wsrv.nl/?url=${encodeURIComponent(
                        item.poster
                      )}&w=280&h=444&fit=cover&output=webp&ll`}
                      alt={item.title}
                      fill
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                </Link>
              </Card>
            </Carousel.Slide>
          ))}
      </Carousel>
    </Box>
  )
}

SimilarCarousel.propTypes = {}

export default SimilarCarousel
